module.exports = __webpack_public_path__ + "img/img02.560abbec.jpg";